import React, { useState }  from "react";
import { connect } from "react-redux";
import SelectOption from "components/select/SelectOption";
import SummaryCard from "components/widget/SummaryCard";
import { LucideCalendar, LucideCircleCheck, LucideCircleX, LucideClock } from "lucide-react";
import WeeklyAttendanceOverview from "./components/WeeklyAttendanceOverview";
import CalendarView from "./components/CalendarView";
import EmployeeAttendanceTable from "./components/EmployeeAttendanceTable";

const AttendanceOverview = () => {
	const [selectedMonth = 0, setSelectedMonth] = useState(0);
	return (
		<div>
			<div className="flex mt-4">
				<SelectOption
					style={{ width: 200 }}
					size="medium"
					options={[
						{label:"October 2025", value: 0},
						{label:"September 2025", value: 1},
						{label:"August 2025", value: 2},
					]}
					value={selectedMonth}
					onChange={(value) => setSelectedMonth(value)}
				/>
			</div>
			<div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 3xl:grid-cols-4">
				<SummaryCard
					title={"Total Present"}
					icon={<LucideCircleCheck size={16} className="text-green-600"/>}
					displayCount={22}
					description={"Days this month"}
					textColor="text-green-600"
				/>	

				<SummaryCard
					title={"Total Absent"}
					icon={<LucideCircleX size={16} className="text-red-600"/>}
					displayCount={2}
					description={"Days this month"}
					textColor="text-red-600"
				/>
				<SummaryCard
					title={"Late Arrivals"}
					icon={<LucideClock size={16} className="text-orange-600"/>}
					displayCount={8}
					description={"Instances this month"}
					textColor="text-orange-600"
				/>		
				<SummaryCard
					title={"Avg. Attendance"}
					icon={<LucideCalendar size={16} className="text-black-600"/>}
					displayCount={"92%"}
					description={"This month"}
					textColor="text-black-600"
				/>	
			</div>
			<div className="grid grid-cols-3 gap-4 mt-6">
				<div className="col-span-2">
					<WeeklyAttendanceOverview/>
				</div>
				<div>
					<CalendarView/>
				</div>
			</div>
			<div className="mt-6">
				<EmployeeAttendanceTable/>
			</div>
		</div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceOverview);